import React from 'react'
import styled from 'styled-components'
import { FilterIcon } from '../../utility/icons'
import styles from '../../utility/styles'
import Button from '../shared/Button'
import Text from '../shared/Text'

const Wrapper = styled.div`
	position: absolute;
	top: 32px;
	right: 48px;
	width: ${({ isExpanded }) => (isExpanded ? '320px' : '24px')};
	height: ${({ isExpanded }) => (isExpanded ? 'auto' : '24px')};
	border-radius: 8px;
	background-color: var(--tz-surface-raised, #1A202C);
	box-sizing: content-box;
	padding: 16px;
	transition: 0.5s;
	@media only screen and ${styles.breakpoints.desktop} {
		top: calc(180px + 24px);
	}
	@media screen and (max-width: 450px) {
		top: 24px;
		right: 24px;
		left: ${({ isExpanded }) => (isExpanded ? '24px' : 'calc(100vw - (24px + 16px + 24px))')}; // 24 margin + 16 padding + 24 icon!
		width: ${({ isExpanded }) => isExpanded ? 'auto' : '24px'};
		height: ${({ isExpanded }) => (isExpanded ? 'auto' : '24px')};
		padding: 8px;
	}
	@media screen and (max-height: 450px) {
		top: 24px;
		right: calc(8px + env(safe-area-inset-right));
		left: ${({ isExpanded }) => (isExpanded ? 'calc(8px + env(safe-area-inset-left))' : 'calc(100vw - (calc(8px + env(safe-area-inset-right)) + 16px + 24px))')}; // 24 margin + 16 padding + 24 icon!
		width: ${({ isExpanded }) => isExpanded ? 'auto' : '24px'};
		height: ${({ isExpanded }) => (isExpanded ? 'auto' : '24px')};
		padding: 8px;
	}
`

const FilterButtonWrapper = styled.div`
	display: flex;
	padding: 0;
	margin-bottom: 16px;
	justify-content: space-between;
	width: 100%;
	box-sizing: content-box;
	overflow: hidden;
	cursor: pointer;
`

const IconContainer = styled.div`
	display: flex;
`

const SwitchWrapper = styled.div`
	display: flex;
	overflow: hidden;
	border-top: 1px solid ${styles.colors.mediumGray};
	padding-top: 16px;
	width: ${({ isExpanded }) => (isExpanded ? '100%' : '0')};
	box-sizing: content-box;
	justify-content: space-between;
	align-items: center;
`

const SwitchContainer = styled.label`
	position: relative;
	display: inline-block;
	width: 48px;
	height: 32px;
`

const SwitchSpan = styled.span`
	position: absolute;
	cursor: pointer;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: ${({ active }) =>
		active ? styles.colors.success : styles.colors.lightGray};
	-webkit-transition: 0.4s;
	transition: 0.4s;
	border-radius: 16px;
	&:before {
		position: absolute;
		content: '';
		height: 28px;
		width: 28px;
		left: 2px;
		bottom: 2px;
		background-color: ${styles.colors.white};
		border-radius: 14px;
		transform: translateX(${({ active }) => (active ? '16px' : '0')});
		transition: 0.4s;
	}
`

export default function FilterButton({
	isExpanded,
	expand,
	closeIt,
	isNonTeslaOnly,
	toggle,
	style,
}) {
	return (
		<Wrapper {...{ isExpanded }}>
			<FilterButtonWrapper
				variant='secondary'
				hideShadow
				onClick={isExpanded ? closeIt : expand}
				{...{ style }}
			>
				<IconContainer>
					<FilterIcon style={{ marginRight: '16px' }} />
					<Text.Heading type='h6' variant='bold'>
						Filter
					</Text.Heading>
				</IconContainer>
				<Button
					onClick={closeIt}
					style={{ padding: '0', zIndex: 100 }}
					variant='secondary'
					hideShadow
				>
					<svg
						xmlns='http://www.w3.org/2000/svg'
						width='24'
						height='24'
						viewBox='0 0 24 24'
						fill='none'
					>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12ZM7.05025 7.05025C7.44078 6.65973 8.07394 6.65973 8.46447 7.05025L12 10.5858L15.5355 7.05025C15.9261 6.65973 16.5592 6.65973 16.9497 7.05025C17.3403 7.44078 17.3403 8.07394 16.9497 8.46447L13.4142 12L16.9497 15.5355C17.3403 15.9261 17.3403 16.5592 16.9497 16.9497C16.5592 17.3403 15.9261 17.3403 15.5355 16.9497L12 13.4142L8.46447 16.9497C8.07394 17.3403 7.44078 17.3403 7.05025 16.9497C6.65973 16.5592 6.65973 15.9261 7.05025 15.5355L10.5858 12L7.05025 8.46447C6.65973 8.07394 6.65973 7.44078 7.05025 7.05025Z'
							fill='white'
						/>
					</svg>
				</Button>
			</FilterButtonWrapper>
			<SwitchWrapper {...{ isExpanded }}>
				<Text.Body
					{...{ isExpanded }}
					color={styles.colors.lightGray}
					style={{ whiteSpace: 'nowrap' }}
				>
					Open to non-Tesla vehicles
				</Text.Body>
				<SwitchContainer onClick={toggle}>
					<SwitchSpan active={isNonTeslaOnly} />
				</SwitchContainer>
			</SwitchWrapper>
		</Wrapper>
	)
}
